import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { useCohortFlag } from 'src/modules/hooks/useCohortFlag'
import { WEB_MARKETING_HERO_IMAGE } from 'src/modules/reducers/cohorts/constants'
import { useHeroImageByWidth } from 'src/modules/hooks/useHeroImageByWidth'

export default (props) => {
  const heroImage = useCohortFlag(WEB_MARKETING_HERO_IMAGE)
  const heroImageByWidth = useHeroImageByWidth(heroImage)
  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      title={'Stream & DVR live sports'}
      subtitle={'Catch your games on your TV, phone, tablet & more.'}
      networkSet="sports"
      showRSN={true}
      poster={heroImageByWidth}
      isHeroDefault={!heroImageByWidth}
    />
  )
}
